<template>

  <b-card :class="'card-' + backgroundColor">
    <div class="bold-text level-three-title">
      {{ $t(title) }}
      <b-icon v-if="chargesPro" id="info-circle-expense" class="ml-2" icon="info-circle"
              variant="primary"></b-icon>
      <b-tooltip v-if="chargesPro" aria-rowcount="3" html
                 target="info-circle-expense" variant="dark">
        {{ this.$t('ProfessionalCharges') + ': ' + chargesPro + '€' }} <br>
      </b-tooltip>
      <b-icon v-if="explanationFacture" id="info-circle-explanation" class="ml-2" icon="info-circle"
              variant="primary"></b-icon>
      <b-tooltip v-if="explanationFacture" aria-rowcount="3" html
                 target="info-circle-explanation" variant="dark">
        {{ this.$t(explanationFacture) }}
      </b-tooltip>
      <b-icon v-if="explanationApport" id="info-circle-explanation-apport" class="ml-2" icon="info-circle"
              variant="primary"></b-icon>
      <b-tooltip v-if="explanationApport" aria-rowcount="3" html
                 target="info-circle-explanation-apport" variant="dark">
        {{ this.$t(explanationApport) }}
      </b-tooltip>
    </div>
    <div class="huge-text">
      {{ value }}
    </div>
  </b-card>

</template>

<script>

export default {

  name: 'CardComponent',

  props: {
    title: String,
    backgroundColor: {
      String,
      default: "main-color"
    },
    value: String,
    chargesPro: {
      type: String,
      required: false,
      default: null
    },
    interests: {
      type: String,
      required: false,
      default: null
    },
    explanationFacture: {
      type: String,
      required: false,
      default: null
    },
    explanationApport: {
      type: String,
      required: false,
      default: null
    }

  },

  methods: {}

}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/b122/CardComponent.vue